<div class="component-container">


<div class="login-container">
    <h1>Member Login</h1>
    <form #form="ngForm" (ngSubmit)="login(form)">
        <div class="form-group">
            <label for="email">Email</label>
            <input type="email" name="email" placeholder="Enter your email" [(ngModel)]="email" autocomplete="off" required>
        </div>
        <div class="form-group">
            <label for="password">Password</label>
            <div class="password-container">
                <input [type]="toggle ? 'text' : 'password'" name="password" placeholder="Enter your password"
                 [(ngModel)]="password" autocomplete="off" required
                 #credential="ngModel"
                 >
                <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggleView()">Show</button>
            </div>
           
        </div>
        <button type="submit" class="btn" [disabled]="form.invalid">Login</button>
        <a [routerLink]="['/']" class="forgot-password" (click)="cancel()">Cancel</a>
        <a [routerLink]="['/']" class="forgot-password" (click)="openLoginDialog()">Admin Login</a>
    </form>
</div>
</div>